import { Line } from "@ant-design/plots";
import styled from "styled-components";
import { formatDataNumberToen } from "../../../helper/helper";

const DashboardCompare = ({ dataChart, startDate, endDate }) => {
  const config = {
    data: dataChart,
    xField: "hour",
    yField: "total_hour",
    seriesField: "category",
    color: ["#5B8FF9", "#5AD8A6", "#fd4f24"],
    point: {
      shapeField: "square",
      sizeField: 4,
    },
    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)}` ,
      },
    },
    tooltip: {
      formatter: (datum) => ({
        name: 'Total',
        value: `${formatDataNumberToen(+datum["total_hour"])}`,
      }),
    },
    lineStyle: ({ category }) => {
      return {
        lineDash: category === endDate ? [4, 4] : null,
        opacity: category === startDate ? 0.6 : 1,
      };
    },
  };

  return (
    <Container>
      <div className="line-chart__dashboard">
        <Line {...config} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  overflow: auto;
  .line-chart__dashboard {
    min-width: 1000px;
    overflow: auto;
  }
`;
export default DashboardCompare;
